var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-scrollbar',{staticClass:"ls-layout ls-scrollbar"},[_c('div',{staticClass:"ls-view"},[_c('perm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }